module.exports = __webpack_public_path__ + "img/teamwork5.7d06a625.jpeg";